import { Box, Flex } from '@/ui';
import { BAR } from './constants';

export const CardsThumbnail = () => (
  <Flex direction="column" gap="7px" pt={1} w="full">
    {[0, 1].map((i) => (
      <Box
        bg={BAR}
        borderRadius="3px"
        h="18px"
        key={i}
        opacity={i === 0 ? 1 : 0.6}
        w="full"
      />
    ))}
  </Flex>
);
